/**
 * The member detail route (DNKADM-0464): ONE definition shared by `router.tsx` (the child path)
 * and every link to it, so no call site hand-builds `/members/${id}`.
 */
import { generatePath } from 'react-router-dom';

/** Child path under the app shell (no leading slash, as `createBrowserRouter` children are). */
export const MEMBER_DETAIL_ROUTE = 'members/:contactId';

/** The absolute href of one member's detail page. */
export function memberDetailPath(contactId: string): string {
  return generatePath(`/${MEMBER_DETAIL_ROUTE}`, { contactId });
}
